export default __webpack_public_path__ + "static/media/chapter.3e3b72af.svg";